/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.system-package').directive('gccsPopupSystemPackageClientsExceed', [
  'popupDirectiveConfig',
  popupDirectiveConfig =>
    popupDirectiveConfig.configure({
      bodyTemplate: require('./template.pug')
    })
]);
